import { Action } from 'redux';
import { PlanSortByAttributeStateStructure } from './interfaces/plan-sort-by-attribute.state.interface';

const INITIAL_STATE_STRUCTURE: PlanSortByAttributeStateStructure = {
  activeSortMethod: null
};

/** ACTION CLASS */
export class PlanSortByAttributeAction implements Action {
  type: string;
  activeSortMethod?: string;
}

/** ACTIONS TYPES */
const RESET_SORT_BY = 'RESET_SORT_BY';
const SET_SORT_BY = 'SET_SORT_BY';

/** ACTIONS */
export function resetSort(): PlanSortByAttributeAction {
  return { type: RESET_SORT_BY };
}
export function setSortBy(activeSortMethod: string): PlanSortByAttributeAction {
  return { type: SET_SORT_BY, activeSortMethod };
}

export const PLAN_SORT_BY_ATTRIBUTE = 'PlanSortByAttribute';
export function PlanSortByAttribute(
  state: PlanSortByAttributeStateStructure = INITIAL_STATE_STRUCTURE,
  action: PlanSortByAttributeAction
) {

  const copiedState: PlanSortByAttributeStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case SET_SORT_BY:
      copiedState.activeSortMethod = action.activeSortMethod;
      return Object.assign({}, state, copiedState);

    case RESET_SORT_BY:
      return Object.assign({}, state, INITIAL_STATE_STRUCTURE);

    default:
      return state;

  }
}
